import React, { type FC } from 'react';

export const PopularRebrandSvg: FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.92303 6H8.00394V4H13.3373V9.33333H11.3373V7.41419L8.00392 10.7475L6.67059 9.41422L4.0861 11.9988L2.67188 10.5845L6.67058 6.58578L8.00392 7.91912L9.92303 6Z"
                fill="black"
            />
        </svg>
    );
};
